import { Replacement } from '@src/types/checks'

const getAutoFixable = (replacements: Replacement[]): boolean => replacements.length > 0

export default getAutoFixable



// WEBPACK FOOTER //
// ./src/state/analytics/utils/getAutoFixable.ts